import { Injectable, signal } from '@angular/core';

export interface DeliveryLocation {
  id: string;
  name: string;
  type: 'district' | 'province' | 'region';
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  // We can default to Lima (Cercado)
  public currentLocation = signal<DeliveryLocation>({
    id: 'lima',
    name: 'Lima (Cercado)',
    type: 'district'
  });

  // 43 Districts of Lima Province
  public availableLocations: DeliveryLocation[] = [
    { id: 'lima', name: 'Lima (Cercado)', type: 'district' },
    { id: 'ancon', name: 'Ancón', type: 'district' },
    { id: 'ate', name: 'Ate', type: 'district' },
    { id: 'barranco', name: 'Barranco', type: 'district' },
    { id: 'brena', name: 'Breña', type: 'district' },
    { id: 'carabayllo', name: 'Carabayllo', type: 'district' },
    { id: 'chaclacayo', name: 'Chaclacayo', type: 'district' },
    { id: 'chorrillos', name: 'Chorrillos', type: 'district' },
    { id: 'cieneguilla', name: 'Cieneguilla', type: 'district' },
    { id: 'comas', name: 'Comas', type: 'district' },
    { id: 'el-agustino', name: 'El Agustino', type: 'district' },
    { id: 'independencia', name: 'Independencia', type: 'district' },
    { id: 'jesus-maria', name: 'Jesús María', type: 'district' },
    { id: 'la-molina', name: 'La Molina', type: 'district' },
    { id: 'la-victoria', name: 'La Victoria', type: 'district' },
    { id: 'lince', name: 'Lince', type: 'district' },
    { id: 'los-olivos', name: 'Los Olivos', type: 'district' },
    { id: 'lurigancho-chosica', name: 'Lurigancho-Chosica', type: 'district' },
    { id: 'lurin', name: 'Lurín', type: 'district' },
    { id: 'magdalena-del-mar', name: 'Magdalena del Mar', type: 'district' },
    { id: 'miraflores', name: 'Miraflores', type: 'district' },
    { id: 'pachacamac', name: 'Pachacámac', type: 'district' },
    { id: 'pucusana', name: 'Pucusana', type: 'district' },
    { id: 'pueblo-libre', name: 'Pueblo Libre', type: 'district' },
    { id: 'puente-piedra', name: 'Puente Piedra', type: 'district' },
    { id: 'punta-hermosa', name: 'Punta Hermosa', type: 'district' },
    { id: 'punta-negra', name: 'Punta Negra', type: 'district' },
    { id: 'rimac', name: 'Rímac', type: 'district' },
    { id: 'san-bartolo', name: 'San Bartolo', type: 'district' },
    { id: 'san-borja', name: 'San Borja', type: 'district' },
    { id: 'san-isidro', name: 'San Isidro', type: 'district' },
    { id: 'san-juan-de-lurigancho', name: 'San Juan de Lurigancho', type: 'district' },
    { id: 'san-juan-de-miraflores', name: 'San Juan de Miraflores', type: 'district' },
    { id: 'san-luis', name: 'San Luis', type: 'district' },
    { id: 'san-martin-de-porres', name: 'San Martín de Porres', type: 'district' },
    { id: 'san-miguel', name: 'San Miguel', type: 'district' },
    { id: 'santa-anita', name: 'Santa Anita', type: 'district' },
    { id: 'santa-maria-del-mar', name: 'Santa María del Mar', type: 'district' },
    { id: 'santa-rosa', name: 'Santa Rosa', type: 'district' },
    { id: 'santiago-de-surco', name: 'Santiago de Surco', type: 'district' },
    { id: 'surquillo', name: 'Surquillo', type: 'district' },
    { id: 'villa-el-salvador', name: 'Villa El Salvador', type: 'district' },
    { id: 'villa-maria-del-triunfo', name: 'Villa María del Triunfo', type: 'district' }
  ];

  setLocation(location: DeliveryLocation) {
    this.currentLocation.set(location);
    // Here we could also save it to localStorage
    try {
      localStorage.setItem('delivery_location', JSON.stringify(location));
    } catch (e) {}
  }

  loadLocation() {
    try {
      const saved = localStorage.getItem('delivery_location');
      if (saved) {
        this.currentLocation.set(JSON.parse(saved));
      }
    } catch (e) {}
  }

  constructor() {
    this.loadLocation();
  }
}
